import lodash from 'lodash';
import React from 'react';

import styles from './statics/styles/viewer-inline-toolbar-scss.js';
import addTextSelectionListener from './TextSelectionListener.js';

type Props = {
  children: (text: string) => JSX.Element;
  container: HTMLElement;
};

export default class TextSelectionToolbar extends React.Component<
  Props,
  { selectedText: string; selectedTextPosition?: { x: number; y: number } }
> {
  constructor(props: Props) {
    super(props);
    this.state = { selectedText: '' };
  }

  removeTextSelectionListener?: () => void | null;

  componentDidMount() {
    this.addTextSelectionListener(this.props.container);
  }

  componentWillUnmount() {
    if (this.removeTextSelectionListener) {
      this.removeTextSelectionListener();
    }
  }

  componentWillReceiveProps(nextPros: Props) {
    this.addTextSelectionListener(nextPros.container);
  }

  addTextSelectionListener = (container: HTMLElement) => {
    if (container && !this.removeTextSelectionListener) {
      this.removeTextSelectionListener = addTextSelectionListener(container, this.setSelectedText);
    }
  };

  setSelectedText = lodash.debounce(
    (selectedText, selectedTextPosition) => this.setState({ selectedText, selectedTextPosition }),
    50
  );

  render() {
    const { selectedText, selectedTextPosition } = this.state;
    const { container, children } = this.props;
    if (!selectedText || !selectedTextPosition) {
      return null;
    }
    const { left } = container.getBoundingClientRect();
    const topOffset = 5;
    const containerOffset = this.props.container.getBoundingClientRect().top;
    const style = {
      top: selectedTextPosition.y - containerOffset - topOffset - window.scrollY,
      left: selectedTextPosition.x - left,
    };

    return (
      <div className={styles.toolbar} style={style}>
        {children(selectedText)}
      </div>
    );
  }
}
